<template>
  <div class="consultingServicePage creditIndex">
    <v-topBar :yellowPageColumn='yellowPageColumn'
              :productAndSolutionColumn='productAndSolutionColumn'
              :hitSearchUrl='hitSearchUrl'
              :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl">
    </v-topBar>
    <v-header class="hidden-xs hidden-sm"
              :navigationColumnInfos='navigationColumnInfos'
              :webConfigInfo='webConfigInfo'
              :hitSearchUrl='hitSearchUrl'
              :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl">
    </v-header>
    <el-row>
      <el-col :span="24">
        <div class="bgImg" style="cursor: pointer;"></div>
        <div class="row2">
            <el-carousel :interval="4000" type="card" class="hidden-xs" height="376px" arrow="never" :autoplay="false" indicator-position="none" @change="setClass">
              <el-carousel-item v-for="(item,index) in credit" :key="item.id">
                <div :class="`${itemIndex == credit.length-1 && credit.length>=3  ? 'main item':'main'}`" @click="getName(item)">
                  <div class="mainTop">
                    <div class="mainActiveBg" v-if="itemIndex == index">
                      <img :src="item.backgroundUrl" alt="">
                    </div>
                    <img :src="`${itemIndex == index? item.serviceIcon+'_active.png':item.serviceIcon+'_normal.png'}`" alt="">
                    <h3 class="medium" :style="item.serviceLogo.length<=0 && itemIndex != index ? 'opacity: 0.25':''">{{ item.serviceName }}</h3>
                    <p :style="item.serviceLogo.length<=0 && itemIndex != index ? 'opacity: 0.25':''">{{ item.serviceIntroduce}}</p>
                  </div>
                  <el-button @click="see(item.url, '立即购买按钮-上')" v-if="item.serviceLogo.length>0">
                    立即购买
                  </el-button>
                  <el-button @click="see(item.url, '立即购买按钮-上')" v-else disabled  style="opacity: 0.25">
                    敬请期待
                  </el-button>
                </div>
              </el-carousel-item>
            </el-carousel>
          <div style="overflow :hidden;">
            <el-carousel :interval="4000" type="card" class="hidden-sm hidden-md hidden-lg"  height="248px" arrow="never" :autoplay="false" indicator-position="none" @change="setClass">
              <el-carousel-item v-for="(item,index) in credit" :key="item.id">
                <div :class="`${itemIndex == credit.length-1 && credit.length>=3  ? 'main item':'main'}`" @click="getName(item)">
                  <div class="mainTop">
                    <div class="mainActiveBg" v-if="itemIndex == index">
                      <img :src="item.backgroundUrl" alt="">
                    </div>
                    <img :src="`${itemIndex == index? item.serviceIcon+'_active.png':item.serviceIcon+'_normal.png'}`" alt="">
                    <h3 class="medium" :style="item.serviceLogo.length<=0 && itemIndex != index ? 'opacity: 0.25':''">{{ item.serviceName }}</h3>
                    <!--<p :style="item.serviceLogo.length<=0 && itemIndex != index ? 'opacity: 0.25':''">{{ item.serviceIntroduce}}</p>-->
                  </div>
                  <el-button @click="see(item.url, 'banner按钮-上')" v-if="item.serviceLogo.length>0">
                    立即购买
                  </el-button>
                  <el-button @click="see(item.url, 'banner按钮-上')" v-else disabled  style="opacity: 0.25">
                    敬请期待
                  </el-button>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>

          <div class="creditContent" v-if="visibleText==0">
            <el-row>
              <el-col :xs="4" :sm="4" :md="7" :lg="7" :xl="7"><span>安心采服务</span></el-col>
              <el-col :xs="9" :sm="10" :md="10" :lg="10" :xl="10"><span>服务项目</span></el-col>
              <el-col :xs="11" :sm="10" :md="7" :lg="7" :xl="7">
                <span>
                  <h3>基础版服务</h3>
                  <span style="margin: 0px;display: block;">（498 RMB/年）</span>
                </span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="4" :sm="4" :md="7" :lg="7" :xl="7" style="height:168px;">
                <span><img class="hidden-xs hidden-sm" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/recommend_icon4.png" alt="" style="margin-right: 16px;display: block;float: left;">
                <span style="display: block;float: left;">商机匹配<br />
                <span style="font-size: 14px;" class="hidden-xs">（主动触达供应商）</span></span></span>
              </el-col>
              <el-col :xs="9" :sm="10" :md="10" :lg="10" :xl="10">
                <el-row>
                  <el-col :span="24">
                    <span>对匹配供应商进行商机消息推送</span>
                  </el-col>
                  <el-col :span="24">
                    <span>对匹配供应商对工作台推送广告</span>
                  </el-col>
                  <el-col :span="24">
                    <span>使用邮件主动推送匹配供应商</span>
                  </el-col>
                  <el-col :span="24">
                    <span>使用短信服务主动推送匹配供应商</span>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xs="11" :sm="10" :md="7" :lg="7" :xl="7">
                <el-row>
                  <el-col :span="24">
                    <span>
                      <p><span></span></p>
                    </span>
                  </el-col>
                  <el-col :span="24">
                    <span>
                      <p><span></span></p>
                    </span>
                  </el-col>
                  <el-col :span="24">
                    <span>
                      <p><span></span></p>
                    </span>
                  </el-col>
                  <el-col :span="24">
                    <span>
                      <p class="not"><span><span class="notMark">无</span></span></p>
                    </span>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="4" :sm="4" :md="7" :lg="7" :xl="7" style="height:168px;">
                <span><img class="hidden-xs hidden-sm" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/recommend_icon8.png" alt="" style="margin-right: 16px;">平台推荐</span>
              </el-col>
              <el-col :xs="9" :sm="10" :md="10" :lg="10" :xl="10">
                <el-row>
                  <el-col :span="24">
                    <span>服务号优质企业推送</span>
                  </el-col>
                  <el-col :span="24">
                    <span>服务号项目推送</span>
                  </el-col>
                  <el-col :span="24">
                    <span>一链网首页轮播banner</span>
                  </el-col>
                  <el-col :span="24">
                    <span>招标公告翻页下方广告banner</span>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xs="11" :sm="10" :md="7" :lg="7" :xl="7">
                <el-row>
                  <el-col :span="24">
                    <span>
                      <p><span>1次/年</span></p>
                    </span>
                  </el-col>
                  <el-col :span="24">
                    <span>
                      <p><span>1次/年</span></p>
                    </span>
                  </el-col>
                  <el-col :span="24">
                    <span>
                      <p class="not"><span><span class="notMark">无</span></span></p>
                    </span>
                  </el-col>
                  <el-col :span="24">
                    <span>
                      <p><span>5天/年</span></p>
                    </span>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="4" :sm="4" :md="7" :lg="7" :xl="7" style="height: 84px;">
                <span><img class="hidden-xs hidden-sm" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/%E5%BE%81%E4%BF%A1%E6%9C%8D%E5%8A%A1.png" alt="" style="margin-right: 16px;">征信服务</span>
              </el-col>
              <el-col :xs="9" :sm="10" :md="10" :lg="10" :xl="10">
                <el-row>
                  <el-col :span="24">
                    <span>找关系（项目外）</span>
                  </el-col>
                  <el-col :span="24">
                    <span>企业监控</span>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xs="11" :sm="10" :md="7" :lg="7" :xl="7">
                <el-row>
                  <el-col :span="24">
                    <span>
                      <p><span>20次/年</span></p>
                    </span>
                  </el-col>
                  <el-col :span="24">
                    <span>
                      <p><span>3家/年</span></p>
                    </span>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="4" :sm="4" :md="7" :lg="7" :xl="7" style="height: 126px;">
                <span><img class="hidden-xs hidden-sm" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/%E6%95%B0%E6%8D%AE%E6%9C%8D%E5%8A%A1.png" alt="" style="margin-right: 16px;">数据服务</span>
              </el-col>
              <el-col :xs="9" :sm="10" :md="10" :lg="10" :xl="10">
                <el-row>
                  <el-col :span="24"><span>采招业务数据</span></el-col>
                  <el-col :span="24"><span>履约业务数据</span></el-col>
                  <el-col :span="24"><span>供应商业务数据</span></el-col>
                </el-row>
              </el-col>
              <el-col :xs="11" :sm="10" :md="7" :lg="7" :xl="7">
                <el-row>
                  <el-col :span="24">
                    <span>
                      <p class="not"><span><span class="notMark">无</span></span></p>
                    </span>
                  </el-col>
                  <el-col :span="24">
                    <span>
                      <p class="not"><span><span class="notMark">无</span></span></p>
                    </span>
                  </el-col>
                  <el-col :span="24">
                    <span>
                      <p class="not"><span><span class="notMark">无</span></span></p>
                    </span>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>

            <el-row>
              <el-col :xs="4" :sm="4" :md="7" :lg="7" :xl="7"></el-col>
              <el-col :xs="9" :sm="10" :md="10" :lg="10" :xl="10"><span></span></el-col>
              <el-col :xs="11" :sm="10" :md="7" :lg="7" :xl="7">
                <span>
                  <el-button @click="see(visibleUrl, '立即购买按钮-下')">立即购买</el-button>
                </span>
              </el-col>
            </el-row>
          </div>
          <div class="creditText" v-if="visibleText==10">
            <el-row :gutter="40">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <h3>为什么选择一链网企业监控服务？</h3>
                <p>实时监控企业动态，及时获取企业异常信息，有效规避风险发生</p>
                <p>实时监控企业及企业人员23大维度信息变更，实时动向一网打尽，风吹草动尽在掌握</p>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="textRight">
                <p class="title">数据组成：</p>
                <ul>
                  <li>
                    <p>1.经营信息</p>
                    招投标、招聘、企业资质、商标、专利、著作权信息
                  </li>
                  <li>
                    <p>2.工商信息</p>
                    覆盖全国2.1亿+企业经营数据，包含工商信息、股东信息、高管信息、经营地址、座机等
                  </li>
                  <li>
                    <p>3.资产信息</p>
                    股权出质、动产抵押、融资记录、司法拍卖
                  </li>
                  <li>
                    <p>4.司法涉诉信息</p>
                    包括开庭公告、法院公告、裁判文书、失信信息、行政处罚、被执行人信息、司法协助等信息
                  </li>
                  <li>
                    <p>5.税务信息</p>
                    税务登记号、欠税信息、纳税等级
                  </li>
                </ul>
              </el-col>
            </el-row>
          </div>
          <div class="comingSoon" v-if="visibleText==20">
            <div>
              <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/comingSoon_icon.png" alt="">
              <p>敬请期待</p>
            </div>
          </div>
        </div>
        <div class="creditTextBg" v-if="visibleText==10">
          <p>立即使用企业监控服务规避风险<el-button @click="see(visibleUrl, '立即购买按钮-下')">立即购买</el-button></p>
        </div>

      </el-col>
    </el-row>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      custom-class="dialogReminder">
      <div class="reminderCon">
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/expression_icon.png" alt="">
        <p class="title">您好，此服务仅提供给采购商</p>
        <p><span class="number">1</span>如果您有采购商账号请退出此账号重新登录后再进行购买</p>
        <p><span class="number">2</span>如果您是供应商，我们有“诚意供”服务，专门帮助供应商提高中标率 &nbsp<a @click="$router.push('supplierService')" style="color: #3F88E0;text-decoration: none;cursor: pointer;">立即查看</a></p>
        <!--<p><span class="number">3</span>如您迫不及待想了解“诚意供”服务，请联系在线客服或拨打客服热线：400-108-6116</p>-->
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </div>
    </el-dialog>
    <v-footer :webConfigInfo='webConfigInfo' :footerColumnInfos='footerColumnInfos'></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>

<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import footer from '@/components/v-footer'
  import backToTop from '@/components/backToTop'
  import publiceTit from '@/components/publiceTit'
  import {customActivityDetail, customActivityDetailBuyNow} from '@/assets/js/sensors'
  export default {
    name: '',
    data () {
      return {
        yellowPageColumn: {},
        productAndSolutionColumn: {},
        hitSearchUrl: '',
        enterpriseResourceBaseUrl: '',
        navigationColumnInfos: [],
        webConfigInfo: {},
        footerColumnInfos: [],
        credit: [],
        titleObj: {name: '“安心采”服务', eng: 'PROCUREMENT SERVICE'},
        titleObjrisk: {name: '“安心采”服务的核心价值', eng: 'CORE VALUE'},
        itemIndex:0,
        visibleText:'',
        visibleUrl:'',
        dialogVisible:false
      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-footer': footer,
      'v-backToTop': backToTop,
      'v-publiceTit': publiceTit
    },
    created () {
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCommonInfo', {
      }).then((res) => {
        this.data = res.data;
        this.webConfigInfo = this.data.webConfigInfoDto;
        this.footerColumnInfos = this.data.footerColumnInfos;
        this.navigationColumnInfos = this.data.navigationColumnInfos;
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
      }).catch()
    },
    mounted () {
      this.getProductInfo()
      setTimeout(() => {
        // 埋点
        try {
          customActivityDetail({
            page_title: "安心采"
          })
        } catch (e) {console.log(e)}
      })
    },
    methods: {
      setClass(val){
        this.itemIndex = val;
        $('.el-carousel__mask').remove();
      },
      getName(val){
        this.visibleUrl = val.url;
        this.visibleText = val.serviceType;
      },
      getProductInfo () {
        this.$axios.post('/onelink.mdata.main.api/credit/findCreditProductInfo', {
        }).then((res) => {
          if (res.data.success === true) {
            this.credit = res.data.serviceItems;
            this.visibleUrl = this.credit[0].url;
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      see (e, button_position) {

        if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)){
          this.$alert('<p>请到电脑端进行点击立即购买\n</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            confirmButtonText:'知道了'
          })
        }else{
          if(this.getToken('isLogin') == ''){
            this.$router.push({path:'/login',query:{redirectURL:'/creditReport'}});
          }else if(this.getToken('userTag') == '10'){
            // this.$alert('<p>您是供应商身份，不能购买该服务。</p>', '', {
            //   dangerouslyUseHTMLString: true,
            //   customClass:'mobileText',
            //   center: true,
            //   showClose:false
            // });
            this.dialogVisible = true;
            return false;
          }else{
            window.location.href = e;
          }
        }

        // 埋点
        try {
          customActivityDetailBuyNow({
            page_title: "安心采",
            button_position: button_position
          })
        } catch (err) {
          console.log(err)
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .creditIndex{
    .el-carousel__item h3 {
      margin: 0;
      font-size: 22px;
      color: #857050;
      line-height: 30px;
      white-space: nowrap;
    }
    .el-carousel__item p {
      font-size: 14px;
      color: #857050;
      text-align: center;
      line-height: 24px;
      margin-top:7px;
    }
    .el-carousel__item .el-button{
      width:160px;
      height:40px;
      background: #FFFFFF;
      border: 1px solid #909399;
      border-radius: 4px;
      margin-top:20px;
      font-size: 16px;
      color: #303133;
      line-height: 16px;
      padding: 0px;
    }
    .el-carousel__item .el-button:hover{
      background-image: linear-gradient(180deg, #EACDA3 0%, #D4B07A 96%);
      border: none;
      color: #FFFFFF;
    }
    .el-carousel__item .el-button.is-disabled:hover{
      background: #FFFFFF;
      border: 1px solid #909399;
      color: #303133;
    }
    .el-carousel__item .main .mainTop>img {
      width:64px;
      margin-bottom:3px;
    }
    .el-carousel__item .main{
      width: 288px;
      height: 260px;
      overflow :hidden;
      background: #FFFFFF;
      box-shadow: 0 0 16px 0 rgba(0,0,0,0.10);
      border-radius: 5px;
      position :absolute;
      bottom:44px;
      left: 44px;
      text-align: center;
      transform: scale(1.205);
    }
    .el-carousel__item .main .mainTop{
      background :url("https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/carouselbg_normal.png") no-repeat center top;
      background-size: cover;
      height: 180px;
      padding :16px 28px 0px;
      position :relative;
    }
    .el-carousel__item .main .mainTop .mainActiveBg{
      width :100%;
      height:100%;
      position :absolute;
      top:0px;
      left: 0px;
    }
    .el-carousel__item .main .mainTop .mainActiveBg>img{
      max-height:240px;
      position :absolute;
      right:0px;
      bottom: 0px;
    }
    .el-carousel__item.is-active .main{
      width: 396px;
      height: 336px;
      border-radius: 10px;
      left:50%;
      transform: translateX(-50%) scale(1);
      bottom:20px;
      max-width: 96%;
    }
    .el-carousel__item.is-active .main .mainTop{
      background :url("https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/carouselbg_active.png") no-repeat center top;
      height: 240px;
      padding :24px 34px 0px;
      background-size: cover;
    }
    .el-carousel__item.is-active h3 {
      margin: 0;
      font-size: 32px;
      color: #F8D9AC;
      line-height: 30px;
    }
    .el-carousel__item.is-active p {
      font-size: 16px;
      color: #F8D9AC;
      text-align: center;
      line-height: 32px;
      margin-top:10px;
    }
    .el-carousel__item.is-active .el-button{
      width:200px;
      height:48px;
      background-image: linear-gradient(180deg, #EACDA3 0%, #D4B07A 96%);
      border: none;
      margin-top:24px;
      font-size: 20px;
      color: #FFFFFF;
      line-height: 24px;
    }
    .el-carousel__item.is-active .el-button:hover{
      opacity: 0.8;
      border-radius: 6px;
    }
    .el-carousel__item.is-active .el-button.is-disabled{
      background: #FFFFFF;
      border: 1px solid #909399;
      color: #303133;
      border-radius: 6px;
    }
    .el-carousel__item.is-active .main .mainTop>img {
      width:86px;
      margin-bottom:16px;
    }
    .el-carousel__item.is-active+.el-carousel__item .main{
      right:44px;
      left: auto;
    }
    .el-carousel__item:nth-child(1) .main.item{
      right:44px;
      left: auto;
    }
    .creditContent{
      margin:16px 10px 48px;
      >.el-row{
        /*height:126px;*/
        >.el-col{
          height:100%;
          border-top :1px solid #E8ECF2;
          border-left :1px solid #E8ECF2;
          position :relative;
          font-size: 14px;
          color: #303133;
          >span{
            padding :0px 24px;
            position:absolute;
            top: 50%;
            transform: translateY(-50%);
          }
          >.el-row{
            >.el-col{
              position :relative;
              height:42px;
              &:nth-child(odd){
                background : #F5F6FA;
              }
              >span{
                padding :0px 24px;
                position:absolute;
                top: 50%;
                transform: translateY(-50%);
              }
            }
          }
          &:first-child{
            font-size: 18px;

          }
          &:last-child{
            background: rgba(242, 194, 120, 0.1);
            border-left: 1px solid #F2C278;
            border-right: 1px solid #F2C278;
            border-top: 1px solid rgba(232, 236, 242, 0.5);

            .el-col{
              >span{
                width:100%;
                height:100%;
                >p{
                  min-height: 100%;
                  padding-left:40px;
                  margin:0px;
                  background :url("https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/recommend_icon2.png") no-repeat left center;
                  position :relative;
                  >span{
                    position:absolute;
                    top: 50%;
                    transform: translateY(-50%);
                  }
                }
                >p.not{
                  padding-left:0px;
                  background :none;
                  span.notMark{
                    width :24px;
                    display :inline-block;
                    margin-right:16px;
                    text-align :center;
                  }
                }
              }

              &:nth-child(odd){
                background : rgba(245, 246, 250, 0.5);
              }
              &:nth-child(even){
                background : rgba(255, 255, 255, 0.5);
              }
            }

          }
        }
        &:first-child,&:last-child{
          height:80px;
        }
        &:first-child{
          .el-col{
            font-size: 16px;
            color: #606266;
            line-height: 16px;
            >span{
              width:100%;
              text-align:center;
              h3{
                font-size: 16px;
                line-height: 32px;
                margin:0px;
                color: #F2AA3C;
                background :url("https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/recommend_icon.png") no-repeat left center;
                padding-left :30px;
                display :inline-block;
              }
            }
            &:last-child{
              line-height: 32px;
              color: #303133;
              border-top: 1px solid #F2C278;
              background :rgba(242, 194, 120, 0.1) url("https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/recommend_bg.png") no-repeat right top;
            }
          }
        }
        &:last-child{
          border-bottom: 1px solid #E8ECF2;
          .el-col{
            >span{
              left :50%;
              transform: translate(-50%,-50%);
            }
            &:last-child{
              border-bottom: 1px solid #F2C278;
              .el-button{
                width:180px;
                height:48px;
                background-image: linear-gradient(180deg, #FA7661 0%, #EB2C24 97%);
                border-radius: 4px;
                font-size: 18px;
                color: #FFFFFF;
                line-height: 18px;
                border :none;
              }
            }
          }
        }
        &:nth-child(5),&:nth-child(7){
          >.el-col{
            >.el-row{
              >.el-col{
                &:nth-child(odd){
                  background : #fff;
                }
                &:nth-child(even){
                  background : #F5F6FA;
                }
              }
            }
            &:last-child{
              >.el-row{
                >.el-col{
                  &:nth-child(odd){
                    background : rgba(255, 255, 255, 0.5);
                  }
                  &:nth-child(even){
                    background : rgba(245, 246, 250, 0.5);
                  }
                }
              }
            }
          }
        }
      }
    }
    .creditText{
      margin-top:16px;
      padding:0px 10px 20px;
      color: #303133;
      line-height: 32px;
      h3{
        font-size: 30px;
        line-height: 30px;
        margin:0px 0px 26px;
      }
      p{
        font-size: 16px;
        margin:0px 0px 24px;
      }
      .textRight{
        p{
          font-size: 18px;
          line-height: 36px;
          font-weight :bold;
        }
        ul{
          padding :0px;
          li{
            margin-bottom:16px;
            font-size: 16px;
            p{
              font-size: 16px;
              line-height: 30px;
              margin:0px;
              font-weight :bold;
            }
          }
        }
      }
    }
    .creditTextBg{
      height :120px;
      background-image: linear-gradient(-45deg, #F8F0E2 0%, #C3B096 100%);
      p{
        max-width:1200px;
        padding:0px 10px;
        font-size: 26px;
        line-height: 120px;
        color: #FFFFFF;
        margin:0px auto;
        position :relative;
        .el-button{
          width:240px;
          height:60px;
          background-image: linear-gradient(180deg, #FA7661 0%, #EB2C24 97%);
          box-shadow: 0 0 16px 0 rgba(0,0,0,0.10);
          border-radius: 4px;
          font-size: 26px;
          color: #FFFFFF;
          border :none;
          position:absolute;
          top: 50%;
          transform: translateY(-50%);
          right :10px;
        }
      }
    }
    .comingSoon{
      margin-top:80px;
      margin-bottom:92px;
      text-align :center;
      p{
        font-size: 18px;
        color: #A8ACB2;
        line-height: 24px;
        text-align :center;
        margin-top:24px;
      }
    }
  }
  .bgImg {
    width: 100%;
    height: 360px;
    position: relative;
    background: url('https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/credit_banner.jpg') no-repeat center;
    background-size: cover;
  }
  .partTwo,.partThree{
    text-align: center;
    padding: 50px 0;
  }
  .partTwo {
    font-family: PingFangSC-Regular;
  }
  .partThree {
    background: url('https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/riskcontrol.jpg') no-repeat center top;
    background-size: cover;
    .imgleft {
      background: url('https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/riskstock.jpg');
      max-width: 420px;
      height: 560px;
    }
    .imgrightop {
      background: url('https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/riskinfo.jpg');
    }
    .imgrightbot {
      background: url('https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/risktime.jpg');
    }
    .imgrightop, .imgrightbot {
      max-width: 780px;
      height: 280px;
      text-align: left;
      padding-left: 64px;
    }
    .imgcommon {
      p:nth-child(1) {
        font-family: PingFangSC-Medium;
        font-size: 30px;
        color: #FFFFFF;
        line-height: 30px;
      }
      p:nth-child(2) {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 32px;
      }
    }
    .imgprivate {
      p:nth-child(1) {
        padding-top: 120px;
      }
      p:nth-child(2) {
        padding-top: 30px;
      }
    }
    .imgprivate2 {
      p:nth-child(1) {
        padding-top: 64px;
      }
      p:nth-child(2) {
        padding-top: 12px;
      }
    }
  }
  .row, .row2 {
    max-width: 1200px;
    margin: auto;
    ul {
      padding: 0 12px;
    }
    >li {
      max-height: 420px;
    }
  }
  .row2{
    margin-top: -200px;
  }
  @media screen and (max-width: 767px) {
    .bgImg {
      height: 240px;
      background-size: 960px 240px;
    }
    .row {
      overflow: auto;
      ul {
        width: 512px;
      }
      >li {
        width: 160px;
        height: 280px;
        margin: 0 8px;
        padding: 0;
      }
    }
    .row2 {
      overflow :hidden;
      margin-top: -130px;
      .imgleft {
        width: 100%;
      }
      .imgrightop, .imgrightbot{
        width: 100%;
      }
      .imgcommon {
        p:nth-child(1) {
          font-size: 16px;
          line-height: 24px;
        }
        p:nth-child(2) {
          font-family: PingFangSC-Regular;
          font-size: 12px;
          line-height: 16px;
        }
      }
      .imgprivate {
        p:nth-child(1) {
          padding-top: 31px;
        }
        p:nth-child(2) {
          padding-top: 10px;
        }
      }
      .imgprivate2 {
        p:nth-child(1) {
          padding-top: 16px;
        }
        p:nth-child(2) {
          padding-top: 0;
        }
      }
    }
    .creditIndex{
      .el-carousel__item .main{
        width: 160px;
        height: 160px;
        left: 44px;
      }
      .el-carousel__item h3 {
        margin: 0;
        font-size: 16px;
        line-height: 30px;
      }
      .el-carousel__item .el-button{
        width:90px;
        height:24px;
        border-radius: 3px;
        margin-top:13px;
        font-size: 12px;
        padding :0px;
      }
      .el-carousel__item .main .mainTop>img {
        width:42px;
        margin-bottom:14px;
      }
      .el-carousel__item .main .mainTop{
        height: 110px;
        padding :14px 0px 0px;
      }
      .el-carousel__item .main .mainTop .mainActiveBg>img{
        width :140px;
      }
      .el-carousel__item.is-active .main{
        width: 220px;
        height: 208px;
      }
      .el-carousel__item.is-active .main .mainTop{
        height: 140px;
        padding :14px 26px 0px;
      }
      .el-carousel__item.is-active h3 {
        margin: 0;
        font-size: 18px;
        line-height: 30px;
      }
      .el-carousel__item.is-active .el-button{
        width:142px;
        height:36px;
        margin-top:16px;
        font-size: 16px;
        border-radius :4px;
      }
      .el-carousel__item.is-active .main .mainTop>img{
        width:64px;
        margin-bottom:10px;
      }
      .el-carousel__item.is-active+.el-carousel__item .main{
        right:44px;
      }
      .el-carousel__item:nth-child(1) .main.item{
        right:44px;
        left: auto;
      }
      .creditContent{
        margin:20px 10px 40px;
        >.el-row{
          /*height:126px;*/
          &:nth-child(4){
            >.el-col{
              height:110px!important;
              >.el-row{
                >.el-col{
                  height:110px!important;
                }
              }
            }
          }
          &:nth-child(3){
            >.el-col{
              height :192px!important;
            }
          }
          &:nth-child(2){
            >.el-col{
              height :192px!important;
            }
          }

          >.el-col{
            height:100%;
            border-top :1px solid #E8ECF2;
            border-left :1px solid #E8ECF2;
            position :relative;
            font-size: 12px;
            color: #303133;
            >span{
              padding :0px 10px;
              position:absolute;
              top: 50%;
              transform: translateY(-50%);
            }
            >.el-row{
              >.el-col{
                position :relative;
                height:48px;
                &:nth-child(odd){
                  background : #F5F6FA;
                }
                >span{
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  padding :0px 10px;
                  position:absolute;
                  top: 50%;
                  transform: translateY(-50%);
                }
              }
            }
            &:first-child{
              font-size: 14px;
            }
            &:last-child{
              background: rgba(242, 194, 120, 0.1);
              border-left: 1px solid #F2C278;
              border-right: 1px solid #F2C278;
              border-top: 1px solid rgba(232, 236, 242, 0.5);

              .el-col{
                >span{
                  width:100%;
                  height:100%;
                  >p{
                    width:100%;
                    min-height: 100%;
                    padding-left:26px;
                    margin:0px;
                    background :url("https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/recommend_icon2.png") no-repeat left center;
                    background-size: 16px;
                    position :relative;
                    >span{
                      overflow: hidden;
                      text-overflow: ellipsis;
                      display: -webkit-box;
                      -webkit-line-clamp: 2;
                      -webkit-box-orient: vertical;
                      position:absolute;
                      top: 50%;
                      transform: translateY(-50%);
                    }
                  }
                  >p.not{
                    padding-left:0px;
                    background :none;
                    span.notMark{
                      width :16px;
                      display :inline-block;
                      margin-right:10px;
                      text-align :center;
                    }
                  }
                }

                &:nth-child(odd){
                  background : rgba(245, 246, 250, 0.5);
                }
                &:nth-child(even){
                  background : rgba(255, 255, 255, 0.5);
                }
              }

            }
          }
          &:first-child,&:last-child{
            height:80px;
          }
          &:first-child{
            .el-col{
              font-size: 12px;
              color: #606266;
              line-height: 16px;
              >span{
                width:100%;
                text-align:center;
                line-height: 24px;
                h3{
                  font-size: 14px;
                  line-height: 24px;
                  margin:0px;
                  color: #F2AA3C;
                  background :url("https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/recommend_icon.png") no-repeat left center;
                  background-size: 16px;
                  padding-left :20px;
                  display :inline-block;
                }
                >span{
                  font-size:13px;
                }
              }
              &:last-child{
                line-height: 32px;
                color: #303133;
                border-top: 1px solid #F2C278;
                background :rgba(242, 194, 120, 0.1) url("https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/recommend_bg.png") no-repeat right top;
                background-size: 40px;
              }
            }
          }
          &:last-child{
            border-bottom: 1px solid #E8ECF2;
            .el-col{
              >span{
                left :50%;
                transform: translate(-50%,-50%);
              }
              &:last-child{
                border-bottom: 1px solid #F2C278;
                .el-button{
                  width:120px;
                  height:32px;
                  background-image: linear-gradient(180deg, #FA7661 0%, #EB2C24 97%);
                  border-radius: 4px;
                  font-size: 14px;
                  color: #FFFFFF;
                  line-height: 18px;
                  border :none;
                  padding :0px;
                }
              }
            }
          }
          &:nth-child(5),&:nth-child(7){
            >.el-col{
              >.el-row{
                >.el-col{
                  &:nth-child(odd){
                    background : #fff;
                  }
                  &:nth-child(even){
                    background : #F5F6FA;
                  }
                }
              }
              &:last-child{
                >.el-row{
                  >.el-col{
                    &:nth-child(odd){
                      background : rgba(255, 255, 255, 0.5);
                    }
                    &:nth-child(even){
                      background : rgba(245, 246, 250, 0.5);
                    }
                  }
                }
              }
            }
          }
        }
      }
      .creditText{
        margin-top:20px;
        padding:0px 10px 20px;
        color: #303133;
        line-height: 24px;
        h3{
          font-size: 16px;
          line-height: 24px;
          margin:0px 0px 13px;
        }
        p{
          font-size: 12px;
          margin:0px 0px 12px;
        }
        .textRight{
          margin-top:20px;
          p{
            font-size: 14px;
            line-height: 24px;
            font-weight :bold;
          }
          ul{
            padding :0px;
            li{
              margin-bottom:8px;
              font-size: 12px;
              p{
                font-size: 12px;
                line-height: 24px;
                margin:0px;
                font-weight :bold;
              }
            }
          }
        }
      }
      .creditTextBg{
        height :60px;
        background-image: linear-gradient(-45deg, #F8F0E2 0%, #C3B096 100%);
        p{
          max-width:1200px;
          padding:0px 10px;
          font-size: 14px;
          line-height: 60px;
          color: #FFFFFF;
          margin:0px auto;
          position :relative;
          .el-button{
            width:100px;
            height:32px;
            background-image: linear-gradient(180deg, #FA7661 0%, #EB2C24 97%);
            box-shadow: 0 0 16px 0 rgba(0,0,0,0.10);
            border-radius: 4px;
            font-size: 14px;
            color: #FFFFFF;
            border :none;
            position:absolute;
            top: 50%;
            transform: translateY(-50%);
            right :10px;
            padding :0px;
          }
        }
      }
      .comingSoon{
        margin-top:55px;
        margin-bottom:46px;
        text-align :center;
        img{
          width :160px;
        }
        p{
          font-size: 14px;
          color: #A8ACB2;
          line-height: 24px;
          text-align :center;
          margin-top:12px;
        }
      }
    }
  }
  @media screen and (max-width: 458px){
    .creditIndex{
      .el-carousel {
        width: 458px!important;
        left: 50%;
        transform: translateX(-50%);
      }
      .el-carousel__item .main{
        width: 160px;
        height: 160px;
        left: -49px;
      }
      .el-carousel__item.is-active+.el-carousel__item .main{
        right:-49px;
      }
      .el-carousel__item:nth-child(1) .main.item{
        right:-49px;
        left: auto;
      }
    }
  }
</style>
<style lang="stylus">
  .titleObjrisk {
    margin-bottom: 30px;
  }
  .titleObjrisk .title{
    .titleBg , .titleCon{
      color: #fff;
    }
    .line{
      background: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/creditReport/creditIndex.vue